export var BusinessTaxIdUtilsFactory = (function() {
    /* Public Functions */

    var getBusinessTaxIdUtils = function(countryCode) {
        if ((countryCode.toLowerCase() + 'Utils') in utilsCollection) {
            return new utilsCollection[countryCode.toLowerCase() + 'Utils']();
        } else {
            return new utilsCollection.baseUtils();
        }
    };

    /* Private Variables */
    var utilsCollection = {};

    /* Private Helper Functions */

    // helper for setting up inheritance
    var inheritsFrom = function(child, parent) {
        child.prototype = Object.create(parent.prototype);
    };

    var formatFromService = function(legalIDs) {
        return legalIDs.slice(0, 2);
    };

    var formatToServiceWithoutCountryCode = function(taxId) {
        return {
            legalID: {
                'type': taxId.type,
                'value': taxId.value ? taxId.value.toUpperCase() : undefined
            }
        };
    };

    var formatToServiceWithCountryCode = function(countryCode) {
        var formatToService = function(taxId) {
            return {
                legalID: {
                    'type': taxId.type,
                    'value': taxId.value ? countryCode + taxId.value.toUpperCase() : undefined
                }
            };
        };
        return {
            formatToService: formatToService
        };
    };

    var maskTaxIdWithoutCountryCode = function(taxIdMask) {
        var maskTaxId = function(taxIdValue) {
            if (taxIdMask) {
                return taxIdValue ? taxIdMask + taxIdValue.substr(-3) : '';
            } else {
                return taxIdValue ? '*'.repeat(taxIdValue.length - 3) + taxIdValue.substr(-3) : '';
            }
        };
        return {
            maskTaxId: maskTaxId
        };
    };

    var maskTaxIdWithCountryCode = function(countryCode, taxIdMask) {
        var maskTaxId = function(taxIdValue) {
            if (taxIdMask) {
                return taxIdValue ? countryCode + taxIdMask + taxIdValue.substr(-3) : '';
            } else {
                return taxIdValue ? countryCode + '*'.repeat(taxIdValue.length - 3) + taxIdValue.substr(-3) : '';
            }
        };
        return {
            maskTaxId: maskTaxId
        };
    };

    var commonOneLengthValidator = function(length) {
        var isValidTaxId = function(taxId) {
            if (taxId && taxId.length === length) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var commonTwoLengthsValidator = function(lengthOne, lengthTwo) {
        var isValidTaxId = function(taxId) {
            if (taxId && taxId.length >= lengthOne && taxId.length <= lengthTwo) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    /* Private Utils Functions */

    // Base
    var BaseUtils = function() {};
    BaseUtils.prototype.formatFromService = formatFromService;
    BaseUtils.prototype.formatToService = function() {};
    BaseUtils.prototype.maskTaxId = function() {};
    BaseUtils.prototype.isValidTaxId = function() {};
    utilsCollection.baseUtils = BaseUtils;

    // US
    var usUtils = function() {};
    inheritsFrom(usUtils, BaseUtils);
    usUtils.prototype.formatToService = function(taxId) {
        return {
            legalID: {
                'type': taxId.type,
                'value': taxId.value ? taxId.value.toUpperCase().replace(/(\d{2})(\d{7})/, '$1-$2') : undefined
            }
        };
    };
    usUtils.prototype.maskTaxId = maskTaxIdWithoutCountryCode('**-****').maskTaxId;
    usUtils.prototype.isValidTaxId = commonOneLengthValidator(9).isValidTaxId;
    utilsCollection.usUtils = usUtils;

    // CA
    var caUtils = function() {};
    inheritsFrom(caUtils, BaseUtils);
    caUtils.prototype.formatToService = formatToServiceWithoutCountryCode;
    caUtils.prototype.maskTaxId = maskTaxIdWithoutCountryCode().maskTaxId;
    caUtils.prototype.isValidTaxId = commonTwoLengthsValidator(7, 15).isValidTaxId;
    utilsCollection.caUtils = caUtils;

    /* Expose the public methods */
    return {
        getBusinessTaxIdUtils: getBusinessTaxIdUtils
    };
})();


//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/tax-id/business-tax-id-util.js
// module id = 350
// module chunks = 0